import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {News} from "../../../../interfaces/news/News";
import {environment} from "../../../../../environments/environment.development";
import {rNames} from "../../../../r.names";

import { RouterLink } from '@angular/router';
import {ExtLinkIconComponent} from '../../../../../components/ext-link-icon/ext-link-icon.component';

@Component({
    selector: 'app-homepage-block-item',
    templateUrl: './homepage-block-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, ExtLinkIconComponent]
})
export class HomepageBlockItemComponent {
  news = input<News>({} as News);

  imagesPath: string = environment.imagesPath;
  r = rNames;

}
